import { gql } from "@apollo/client";
import useWrappedMutation from "../../common/data-fetching/useWrappedMutation";

const QUERY_SCOPE = "application";
const QUERY_NAME = "applicationUpdateRecruiterNote";

export const QUERY = gql`
    mutation ${QUERY_SCOPE}_${QUERY_NAME} (
      $id: ID!,
      $recruiterNote: String
    ) {
      ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
          id: $id,
          recruiterNote: $recruiterNote
        ) {
          _id
          recruiterNote
        }
      }
    }
  `;

export default function useMutationApplicationUpdate() {
  return useWrappedMutation(QUERY, QUERY_SCOPE, QUERY_NAME);
}
